<template>    
<div class="card border-0">
  <div class="card-body">

<div v-if="detailsComp == 0" class="row">
  <div class="col-12 d-flex justify-content-center align-items-center">
    <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style=""/>
    <span class="ml-3 h4" style="color:#0E1698">Loading Account...</span>
  </div>
</div>

<slot v-if="detailsComp == 1">
    <div class="row">
      <div class="col-12 col-xl-6  border-xl-right mb-4 mb-xl-0">

        

        <div class="row">
          <div class="col-12">
            <h5 class="text-muted">Account Information</h5>
          </div>
          <div class="form-group col-md-6">
            <label class="small">First Name</label>
            <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="First Name" v-model="f_name">
          </div>
          <div class="form-group col-md-6">
            <label class="small">Last Name</label>
            <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="Last Name" v-model="l_name">
          </div>
          <hr >

          <div class="col-12">
            <h5 class="text-muted">Customer Facing Information</h5>
          </div>
          <div class="col-12">
            <p class="small">The email address and phone number below are used on quotes and emails. If a customer facing email is NOT designated, your login/username email will be used instead.</p>
          </div>

          <div class="form-group col-12">
            <label class="small" for="exampleInputEmail1">Customer Facing Email</label>
            <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="Customer Facing Email" v-model="email">
          </div>
          <div class="form-group col-12 col-md-6">
            <label class="small">Customer Facing Phone Number</label>
            <VuePhoneNumberInput 
                :translations="{
                  phoneNumberLabel: 'Customer Facing Phone',
                }"
                v-model="phone"
                class="w-100"
                default-country-code="US"
                no-country-selector
                no-validator-state
              />
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-right">
            <button class="btn btn-success" :disabled="hasBeenEdited" @click="submitAccountChanges">Save Changes</button>
          </div>
        </div>
        
        
        <hr class="d-block d-xl-none">
      </div>

      <div class="col-12 col-xl-6">
        <div class="row">
          <div class="col-12">
            <h5 class="text-muted">Change Password</h5>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12 col-xl-6">
            <label class="small">Current Password</label>
            <input :type="curr_pswd_type" class="form-control" aria-describedby="emailHelp" placeholder="Current Password" v-model="curr_pass">
            <small class="float-right" @click="showPassword(1)">{{ show_curr_pswd_type }}</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12 col-xl-6">
            <label class="small">New Password</label>
            <input :type="new_pswd_type" class="form-control" aria-describedby="emailHelp" placeholder="New Password" v-model="new_pass">
            <small class="float-right" @click="showPassword(2)">{{ show_new_pswd_type }}</small>
            <br>
            <small class="font-weight-bold font-italic">Password must be at least ten characters long</small>
          </div>

        </div>
        <div class="row mb-3">
          <div class="form-group col-12 col-xl-6">
            <label class="small">Confirm New Password</label>
            <input :type="con_pswd_type" class="form-control" aria-describedby="emailHelp" placeholder="Confirm New Password" v-model="cpswrd">
            <small class="float-right" @click="showPassword(3)">{{ show_con_pswd_type }}</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12 col-xl-6 text-right">
            <label class="small">&nbsp;</label>
            <button class="btn btn-success" @click="submitPassword">Change Password</button>
            
          </div>
        </div>
      </div>

    </div>
</slot>


  </div>
</div>
</template>

<script>
import { ScalingSquaresSpinner } from 'epic-spinners' 
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import {store} from '../../stores/settings-user-main-store.js'

export default {
  store,
  data: function () {
    return { 
      f_name: '',
      l_name: '',
      phone: null,
      email: null,

      curr_pass: '',
      new_pass: '',
      cpswrd: '',

      curr_pswd_type: 'password',
      show_curr_pswd_type: 'Show Password',
      new_pswd_type: 'password',
      show_new_pswd_type: 'Show Password',
      con_pswd_type: 'password',
      show_con_pswd_type: 'Show Password',
    }
  },
  computed: {
    detailsList () { return this.$store.state.detailsList },
    detailsComp () { return this.$store.state.detailsComp },
    hasBeenEdited() {
      if((this.f_name != this.detailsList.f_name) || (this.l_name != this.detailsList.l_name) || (this.phone != this.detailsList.sec_phone) || (this.email != this.detailsList.sec_email)) {
        return false;
      } else {
        return true;
      }
    }
  },
  watch: {
    detailsList() { this.onLoad() }
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    onLoad(){
      var _this = this;
      _this.f_name = _this.detailsList.f_name;
      _this.l_name = _this.detailsList.l_name;
      _this.email = _this.detailsList.sec_email;
      _this.phone = _this.detailsList.sec_phone;
    },

    showPassword(x){
      var _this = this;
      switch (x) {
        case 1:
          if(_this.curr_pswd_type == "password") { 
            _this.curr_pswd_type = 'text';
            _this.show_curr_pswd_type = 'Hide Password'; 
          } else { 
            _this.curr_pswd_type = "password"; 
            _this.show_curr_pswd_type = 'Show Password'; 
          }
          break;
        case 2:
           if(_this.new_pswd_type == "password") { 
            _this.new_pswd_type = 'text';
            _this.show_new_pswd_type = 'Hide Password';  
          } else { 
            _this.new_pswd_type = "password";
            _this.show_new_pswd_type = 'Show Password';  
          }
          break;
        case 3:
          if(_this.con_pswd_type == "password") { 
            _this.con_pswd_type = 'text'; 
            _this.show_con_pswd_type = 'Hide Password'; 
          } else { 
            _this.con_pswd_type = "password"; 
            _this.show_con_pswd_type = 'Show Password'; 
          }
      }
    },

    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-builder':
        _this.getAllUserBuilds();
        _this.getMainView('product-main', '', '', '');
        break;
        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-builder':
          _this.getMainView('product-main', '', '', '');
        break;
        case 'product-view':
          _this.getMainView('product-main', '', '', '');
        break;
        default:
      }
    },
    secondaryAction(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-view':
        _this.getMainView('product-main', '', '', '');
        break;
        default:
      }
    },

    submitAccountChanges() {
      var _this = this;
      var valErrors = [];

      _this.$toastr.warning('Validating changes.', 'Please wait!', {timeOut: 3000})

      var phoneFormat = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
      if(_this.phone != _this.detailsList.sec_phone && _this.phone != '' && _this.phone != null) {
        if(!_this.phone.match(phoneFormat)) { valErrors.push("The customer facing phone number you entered is invalid.") };
      }

      var mailformat = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      if(_this.email != _this.detailsList.sec_email && _this.email != '' && _this.email != null) {  
        if(!_this.email.match(mailformat)) { valErrors.push("The customer facing email you entered is invalid!") };
      }

      if(_this.f_name == "" || _this.f_name == null) {  valErrors.push("A first name is required");  }
      if(_this.l_name == "" || _this.l_name == null) {  valErrors.push("A last name is required");  }

      if(valErrors.length > 0) { _this.errorDisplay(valErrors); _this.$toastr.remove(); return false; }

      _this.$toastr.remove()

      _this.$toastr.warning('Saving changes. This might take a moment..', 'Please wait!', {timeOut: 3000})
      axios.post('/utility/user/user/updateuserdetails', {
        user_id: _this.detailsList.id,
        f_name: _this.f_name,
        l_name: _this.l_name,
        sec_phone: _this.phone,
        sec_email: _this.email,
      })
        .then(function (response) {
          var msg = response.data.msg;
          _this.$toastr.remove()
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.$emit('onSComplete', [ 'settings-account' ])
        })
        .catch(function (error) {
          _this.$toastr.remove()
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })

    },
    submitPassword() {
      var _this = this;
      var valErrors = [];
      _this.$toastr.warning('Validating password information.', 'Please wait!')
      // var passRegex1 = /^(?=.*[a-z])/;
      // var passRegex2 = /^(?=.*[A-Z])/;
      // var passRegex3 = /^(?=.*[0-9])/;
      // var passRegex4 = /^(?=.*[!@#\$%\^&\*])/;
      var passRegex5 = /^(?=.{10,})/;
      
      if(_this.curr_pass == '' || _this.curr_pass == null) { valErrors.push("A current password is required!") } 

      if(_this.new_pass == '' || _this.new_pass == null) { 
        valErrors.push("A new password is required!") } 
      else {
        if(_this.new_pass != _this.cpswrd) { valErrors.push("The new password does not match the password confirmation!") }
        // if(!_this.new_pass.match(passRegex1)) { valErrors.push("A VALID password must include at least 1 lowercase character!") }  
        // if(!_this.new_pass.match(passRegex2)) { valErrors.push("A VALID password must include at least 1 uppercase character!") } 
        // if(!_this.new_pass.match(passRegex3)) { valErrors.push("A VALID password must include at least 1 numeric character!") } 
        // if(!_this.new_pass.match(passRegex4)) { valErrors.push("A VALID password must include at least 1 special character!") }   
        if(!_this.new_pass.match(passRegex5)) { valErrors.push("A VALID password must include at least 10 characters!") }
      }

      if(valErrors.length > 0) {
        _this.$toastr.remove()
        var errors = valErrors;
        var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
        $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
        errorsHTML += '</ul></div>';
        _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
        return false;
      }

      _this.$toastr.remove()
      _this.$toastr.warning('Updating password information.', 'Please wait!')
      axios.post('/utility/user/user/updateuserpassword',{
        curr_pass: _this.curr_pass,
        new_pass: _this.new_pass,
      })
      .then(function (response) {
        var msg = response.data.msg;
        _this.$toastr.remove()
        _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
        _this.$emit('onSComplete', ['password-edit' ])
      })
      .catch(function (error) {
        var errors = error.response.data.errors;
        var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
        $.each(errors, function(key, value){ errorsHTML += '<li>' + value[0] + '</li>' });
        errorsHTML += '</ul></div>';
        _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
      })


    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },
  },    
  components:{
    ScalingSquaresSpinner,
    VuePhoneNumberInput,
  },
  filters: {

  }
}
</script>
